import { OpaccFormValidator } from './opacc.class.formvalidator.js';

/** @module verification */


/**
 * Login- & Registrierungs-Prozess validieren und Registrierungs-Formulare öffnen / schliessen
 *
 */
export class OpaccVerification {
	constructor(){
		this.wrapperElement = document.querySelector('.content');
		this.AddrType = this.wrapperElement.querySelectorAll('.page-register-login input[name="field-reg-type"]');

		if (this.AddrType.length > 0) {
			this.AddrTypeContainer = this.AddrType[0].closest('.opc-button-wrapper');
			this.toggleSelectedForm();
		}

		this.radioListener();
		this.checkboxListener();
		this.validateListener();
		this.slideContentBoxes();
	}

	/**
	 *
	 *
	 */
	slideContentBoxes() {
		this.toggleButtons = document.querySelectorAll('.page-register-login .content-box-body > .opc-button');
		this.contentBoxes = document.querySelectorAll('.page-register-login .content-box-body > .content-box-slide-content');
		Array.from(this.toggleButtons).forEach(button => {
			button.addEventListener('click', () => {
				if (button.previousElementSibling && button.previousElementSibling.classList.contains('content-box-slide-content')) {
					Array.from(this.contentBoxes).forEach(box => {
						box.removeEventListener('transitionend', this.transitionEvent);
						box.classList.remove('is-open');
						box.removeAttribute('style');
						box.style.height = '0';
					});
					button.previousElementSibling.addEventListener('transitionend', this.transitionEvent);
					button.previousElementSibling.classList.add('is-open');
					button.previousElementSibling.style.height = button.previousElementSibling.scrollHeight + 'px';
				}
			});
		});
	}

	/**
	 *
	 *
	 */
	toggleSelectedForm() {
		let initial = this.AddrTypeContainer.querySelector('input[checked]');
		if (initial) {
			this.showActiveForm(initial);
		}

		this.AddrTypeContainer.addEventListener('click', e => {
			let btn = e.target.closest('.page-register-login input[name="field-reg-type"]');
			if (btn) {
				this.showActiveForm(btn);
			}
		});

		this.AddrTypeContainer.addEventListener('keydown', e => {
			if (e.keyCode == 13) {
				let btn = e.target.previousElementSibling;
				if (btn) {
					btn.checked = true;
					btn.setAttribute('checked', 'checked');
					this.showActiveForm(btn);
				}
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} btn
	 */
	showActiveForm(btn) {
		let registerFormContainer = this.AddrType[0].closest('.content-box-body');
		let registerForms = registerFormContainer.querySelectorAll('form');
		let activeForm = registerFormContainer.querySelector(`#${btn.dataset.opFormType}`);
		let openContentBox = document.querySelectorAll('.content-box-slide-content.is-open');
		if (openContentBox.length > 0) {
			Array.from(openContentBox).forEach(box => {
				box.style.height = 'auto';
			});
		}

		Array.from(registerForms).forEach(item => {
			if (item === activeForm) {
				item.style.display = 'flex';
			} else {
				item.style.display = 'none';
			}
		});
	}

	/**
	 *
	 *
	 */
	radioListener() {
		this.wrapperElement.addEventListener('keydown', e => {
			if (e.keyCode == 32 && e.target.classList.contains('opc-radio')) {
				let input = e.target.querySelector('input');
				if (input) {
					input.checked = true;
					input.setAttribute('checked', 'checked');
				}
				e.preventDefault();
			}
		});
	}

	/**
	 *
	 *
	 */
	checkboxListener() {
		this.wrapperElement.addEventListener('keydown', e => {
			if (e.keyCode == 32 && e.target.classList.contains('opc-checkbox')) {
				let input = e.target.querySelector('input');
				if (input) {
					if (input.checked) {
						input.checked = false;
						input.setAttribute('checked', '');
					}
					else {
						input.checked = true;
						input.setAttribute('checked', 'checked');
					}
				}
				e.preventDefault();
			}
		});
	}

	/**
	 *
	 *
	 */
	validateListener() {
		document.addEventListener('DOMContentLoaded', () => {
			const forms = document.querySelectorAll('form');
			Array.from(forms).forEach(form => {
				new OpaccFormValidator(form);
			});
		});
	}

	/**
	 *
	 *
	 * @param {*} e
	 */
	transitionEvent(e) {
		if (e.currentTarget.style.height != '0') {
			e.currentTarget.style.height = 'auto';
		}
	}
}